import "angular-typeform/angular-typeform";
import angular from "angular";

export default angular.module("vui-typeform", ["angularTypeform"])
    .config((typeformConfigProvider) => {
        'ngInject';
        typeformConfigProvider.setAccount('wizerise');
    });
